
<template>
	<div class="hangcai">
		<!-- 搜索条件 -->
		<div class="search_win" style="min-width:1000px;">
			<el-tabs v-model="activeName" @tab-click="handleClick" >
				<el-tab-pane label="详细搜索" name="first">
					<el-form ref="form" :model="form">
						<el-row :gutter="24" style="margin:0px;">
							<el-col :span="8" class="footer_item">
								<el-form-item label="件号" :label-width="formLabelWidth2">
									<el-input size="mini" v-model="form.PN" @keyup.enter.native='search_new'></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" class="footer_item">
								<el-form-item label="描述" :label-width="formLabelWidth2">
									<el-input size="mini" v-model="form.DESCRIBE" @keyup.enter.native='search_new'></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" class="footer_item">
								<el-form-item label="公司名称" :label-width="formLabelWidth2">
									<el-input size="mini" v-model="form.COMPANYNAME" @keyup.enter.native='search_new'></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" class="footer_item">
								<el-form-item label="标准/规范" :label-width="formLabelWidth2">
									<el-input size="mini"  v-model="form.STANDARD" @keyup.enter.native='search_new'></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8" class="footer_item">
								<el-form-item label="适用机型" :label-width="formLabelWidth2">
									<el-input size="mini" v-model="form.AIRMODEL" @keyup.enter.native='search_new'></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24" class="footer_item" style="text-align: right;">
								<el-button size="mini" type="primary" @click='search_new'>搜索</el-button>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="多件搜索" name="second">
					<el-row :gutter="24" style="margin:0px;">
						<el-col :span="24">
							<el-input type="textarea" size="mini" placeholder="输入件号,多个件号用回车键隔开" v-model="form2.PN"></el-input>
						</el-col>
						<el-col :span="24" style="text-align: right;margin-top:10px">
							<el-button size="mini" type="primary"  @click='search_new' @keyup.enter.native='search_new'>搜索</el-button>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div style="height:auto;text-align:right;width:92%;margin:25px auto;overflow:hidden;box-shadow: 5px 5px 5px #c5c6c6;margin-top:25px;">
			<a href="http://www.lightjet.cn/" target="_blank">
				<img src="../../assets/img/lightjet2.png" alt="" style="width:100%;display:block;">
			</a>
		</div>
		<!-- 搜索结果 -->
		<div v-if="tableData.length>0" class="search_win" style="margin-bottom:20px;text-align:right;min-width:1000px;">
			<el-button size="mini" type="primary" @click="allAdd_shopcar" v-if="Login">批量加入购物车</el-button>
			<el-table
			    ref="multipleTable"
			    :data="tableData"
			    tooltip-effect="dark"
			    style="width: 100%"
			    @selection-change="handleSelectionChange">
			    <el-table-column
				  align="center"
			      type="selection"
				  width="55px"
			     >
			    </el-table-column>
				<el-table-column
				align="center"
				  prop="COMPANYNAME"
				  label="公司名称"
				  >
				  <template slot-scope="scope" >
						<span v-if="Login" @click="company_msg(scope.row.COMPANYID)" style="cursor:pointer;color:#409EFF;text-decoration:underline">{{scope.row.COMPANYNAME|| '--' }}</span>
						<span v-else style='color:#409EFF;cursor:pointer' @click="login_win">登陆后查看</span>
				  </template>
				</el-table-column>
			    <el-table-column
					align="center"
					prop="PN"
					label="件号"
			      >
					<template slot-scope="scope">
						<span style="font-weight:bold;">{{scope.row.PN|| '--' }}</span>
					</template>
			    </el-table-column>
			    <el-table-column
					align="center"
					prop="ALT_PN"
					label="替换件号"
			      >
				<template slot-scope="scope">
					{{scope.row.ALT_PN|| '--' }}
				</template>
			    </el-table-column>
				<el-table-column
				align="center"
				  prop="SN"
				  label="批次"
				  >
				  <template slot-scope="scope">
				  	{{scope.row.SN|| '--' }}
				  </template>
				</el-table-column>
				<el-table-column
				align="center"
				  prop="DESCRIBE"
				  label="描述"
				  >
				  <template slot-scope="scope">
				  	{{scope.row.DESCRIBE|| '--' }}
				  </template>
				</el-table-column>
				<el-table-column
				align="center"
				  prop="MANUFACTURER"
				  label="品牌"
				  show-overflow-tooltip>
				  <template slot-scope="scope">
				  	{{scope.row.MANUFACTURER|| '--' }}
				  </template>
				</el-table-column>
				<!-- <el-table-column
				align="center"
				  prop="STANDARD"
				  label="规范/标准"
				  show-overflow-tooltip>
				</el-table-column> -->
				<el-table-column
				align="center"
				  prop="CERS"
				  label="合格证"
				  show-overflow-tooltip>
				  <template slot-scope="scope">
				  	{{scope.row.CERS|| '--' }}
				  </template>
				</el-table-column>
				<el-table-column
				align="center"
				  label="数量"
				  show-overflow-tooltip>
						<template slot-scope="scope">
							<span >{{scope.row.COUNTNUM}} {{scope.row.UNIT}}</span>
						</template>
				</el-table-column>
				<!-- <el-table-column
				align="center"
				  prop="SPEC"
				  label="规格"
				  show-overflow-tooltip>
				</el-table-column> -->
				<!-- <el-table-column
				  align="center"
				  prop="AIRMODEL"
				  label="适用机型"
				  show-overflow-tooltip>
				</el-table-column> -->
				<!-- <el-table-column
				  align="center"
				  label="上架状态"
				  show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.SHELF===0">下架</span>
						<span v-else >上架</span>
					</template>
				</el-table-column> -->
				 <el-table-column label="操作" width="160" align="center">
				      <template slot-scope="scope">
						<el-input-number v-model="scope.row.NUM" controls-position="right" :precision="2" :step="1" :min="1" size="mini"></el-input-number>
						<!-- <el-button type="primary" size="mini"  @click="add_shopcar(scope.row)" style="margin-left:10px;">加入购物车</el-button> -->
						<img src="../../assets/img/shopcar.png" style="width:25px;cursor:pointer;float:right"  @click="add_shopcar(scope.row)" alt />
				      </template>
				    </el-table-column>
			  </el-table>
			  <el-pagination
				style="margin-top: 20px;text-align: center;"
			    background
				@size-change="handleSizeChange"
				@current-change="handleSizeChange"
				:page-size='COUNT'
				:current-page="PAGENUM"
			    layout="prev, pager, next"
			    :page-count="TOTAL">
			  </el-pagination>
		</div>
		<div v-else class="search_win" style="margin-bottom:20px;text-align:center;height:450px;min-width:1000px;">
			<img style="margin-top: 150px;" src="../../assets/img/no_list.png" alt="">
			<div style="color: #8a8a8a;font-weight:bold;margin-top:20px;">暂无数据</div>
			<el-button size="mini" type="primary"  @click="ask_yan" style="margin-top:15px;" >向我们询价</el-button>
		</div>
		<!-- 向我们询价弹窗 -->
		<el-dialog title="向我们询价" :visible.sync="dialogFormVisible" width="50%">
		  <el-form :model="form3" :rules="rules" ref="form3">
			<el-row :gutter="24" style="margin:0 auto;margin-top: 20px;">
				<el-col :span="12">
					<el-form-item label="姓名" :label-width="formLabelWidth">
					  <el-input  v-model="form3.INQUITY_USERNAME"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份" :label-width="formLabelWidth">
					  <el-radio v-model="form3.IDENTITY" label="0">个人</el-radio>
					  <el-radio :disabled="SELLER==0"  v-model="form3.IDENTITY" label="1">公司</el-radio>
					  <span style="color:red;font-size:12px;" v-if="SELLER==0">(需进行卖家资质验证)</span>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="电话" :label-width="formLabelWidth" prop="INQUITY_PHONE">
					  <el-input  v-model="form3.INQUITY_PHONE"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="邮箱" :label-width="formLabelWidth" prop="INQUITY_EMAIL">
					  <el-input  v-model="form3.INQUITY_EMAIL"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="数据类型" :label-width="formLabelWidth">
					  <el-select v-model="form3.DATATYPE" placeholder="请选择" style="width:100%;">
					  	<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					  	</el-option>
					  </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="件号" :label-width="formLabelWidth">
					  <el-input  v-model="form3.PN"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="替换件号" :label-width="formLabelWidth">
					  <el-input  v-model="form3.ALT_PN"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="AOG" :label-width="formLabelWidth">
					  <el-select v-model="form3.AOG" placeholder="请选择" style="width:100%;">
					  	<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
					  	</el-option>
					  </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="描述" :label-width="formLabelWidth">
					  <el-input  v-model="form3.DESCRIBE"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="交货地" :label-width="formLabelWidth">
					  <el-input  v-model="form3.LOCATION"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="应用机型" :label-width="formLabelWidth">
					  <el-input  v-model="form3.AIRMODEL"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="需求日期" :label-width="formLabelWidth">
						<el-date-picker v-model="form3.USEDATE" type="date" placeholder="选择日期" style="width:100%;">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="需求数量" :label-width="formLabelWidth">
					  <el-input-number  v-model="form3.COUNTNUM" :precision="2" :step="1" :min="1" size="mini"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="单位" :label-width="formLabelWidth">
					  <el-input size="mini" v-model="form3.UNIT"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="备注" :label-width="formLabelWidth">
					  <el-input  v-model="form3.REMARK"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button :disabled="disabled" @click="dialogFormVisible = false">取 消</el-button>
		    <el-button :disabled="disabled" type="primary" @click="ask_us('form3')">确 定</el-button>
		  </div>
		</el-dialog>
		<!-- 公司信息弹窗 -->
		<el-dialog
		  title="公司信息"
		  :visible.sync="conpany_dialog"
		  width="30%"
		  >
		  <el-row :gutter="24">
			  <el-col :span="24" class="company_msg"><div style="float:left">公司LOGO：</div><img v-if="companyMsg.LOGO" :src="baseURL+companyMsg.LOGO" class="avatar"><span v-else>--</span></el-col>
		    <el-col :span="24" class="company_msg"><div>公司名称：</div>{{companyMsg.COMPANYNAME||'--'}}</el-col>
		    <el-col :span="24" class="company_msg"><div>行业类型：</div>{{companyMsg.INDUSTRY||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>详细地址：</div>{{companyMsg.ADDRESS||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>企业信用代码：</div>{{companyMsg.COMPANYCODE||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>传真：</div>{{companyMsg.FAX||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>电话：</div>{{companyMsg.CELLPHONE||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>座机号码：</div>{{companyMsg.PHONE||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>网址：</div>{{companyMsg.WEBSITE||'--'}}</el-col>
			<el-col :span="24" class="company_msg"><div>邮箱：</div>{{companyMsg.EMAIL||'--'}}</el-col>
			<el-col :span="24" class="company_msg" style="line-height:30px"><div>公司介绍：</div>{{companyMsg.INTRODUCE||'公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍公司介绍'}}</el-col>
		  </el-row>
		</el-dialog>
	</div>
</template>
<script>
	import {SearchAll,getChemicalsList,getUserInfo,intoCart,getBuyerInfo,specialInquity,getSellerInfo,getCartList} from '../../../utils/api.js'
	import config from '../../../utils/index.js'
	const baseURL = config.baseUrl.dev
	export default {
		data() {
			var checkPhone = (rule, value, callback) => {
			    const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
			    if (!value) {
			      return callback(new Error('电话号码不能为空'))
			    }
			    setTimeout(() => {
			      // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
			      // 所以在前面加了一个+实现隐式转换
			 
			      if (!Number.isInteger(+value)) {
			        callback(new Error('请输入数字值'))
			      } else {
			        if (phoneReg.test(value)) {
			          callback()
			        } else {
			          callback(new Error('电话号码格式不正确'))
			        }
			      }
			    }, 100)
			  }
			  var checkEmail = (rule, value, callback) => {
			    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
			    if (!value) {
			      return callback(new Error('邮箱不能为空'))
			    }
			    setTimeout(() => {
			      if (mailReg.test(value)) {
			        callback()
			      } else {
			        callback(new Error('请输入正确的邮箱格式'))
			      }
			    }, 100)
			  }
			return {
				rules: {
				  INQUITY_PHONE: [
					{ required: true, validator:checkPhone,trigger: 'blur'},
				  ],
				  INQUITY_EMAIL: [
					{ required: true, validator:checkEmail,trigger: 'blur'},
				  ]
				},
				baseURL:baseURL,
				companyMsg:[],
				conpany_dialog:false,
				dialogFormVisible:false,
				Login:false,
				options: [{
				          value: 1,
				          label: '航材'
				        },{
				          value: 2,
				          label: '化工品'
				        }, {
				          value: 3,
				          label: '工具'
					}],
				options2: [{
					value: 1,
					label: '是'
				}, {
					value: 2,
					label: '否'
				}],
				PN:'',
				activeName: 'first',
				formLabelWidth:'100px',
				formLabelWidth2: '100px',
				COUNT:30,
				PAGENUM:1,
				TOTAL:0,
				form: {
					AIRMODEL: '',
					COMPANYNAME: '',
					PN: '',
					DESCRIBE: '',
					STANDARD: '',
					SHELF:1,
				},
				form2: {
					PN: '',
					SHELF:1,
				},
				SELLER:'',
				form3:{
				  IDENTITY:'0',
				  BUYER_USERID: '',
				  INQUITY_USERNAME: '',
				  INQUITY_PHONE: '',
				  INQUITY_EMAIL: '',
				  DATATYPE:2,
				  PN:'',
				  ALT_PN:'',
				  DESCRIBE:'',
				  COUNTNUM:1,
				  UNIT:'',
				  AOG:1,
				  USEDATE:'',
				  LOCATION:'',
				  AIRMODEL:'',
				  REMARK:''
				},
				tableData: [],
				multipleSelection: [],
				USERID:'',
				BUYER:'',
				disabled:false
			}
		},
		components: {},
		mounted() {
			//获取用户信息
			getUserInfo().then(data => {
				let that = this
				if (data.msg == '身份验证出错!'){
					that.Login=false
					// that.$alert('用户登录失效请重新登录！', '提示', {
					// 	confirmButtonText: '确定',
					// 	type: 'warning',
					// 	showClose:false
					// }).then(() => {
					// 	that.$parent.$parent.$parent.$data.searchIndex = 1
					// 	that.$router.push({
					// 		path: '/?new=1'
					// 	})
					// })
				} else {
					that.SELLER = data.Data.SELLER;
					that.USERID = data.Data.USERID;
					that.BUYER = data.Data.BUYER;
					that.COMPANYID=data.Data.COMPANYID;
					that.Login=true
					let params={
						COMPANYID:data.Data.COMPANYID,
						USERID:data.Data.USERID,
					}
					getBuyerInfo(params).then(data => {
						console.log(data)
						  that.form3.BUYER_USERID=data.data.ID
						  that.form3.INQUITY_PHONE=data.data.PHONE
						  that.form3.INQUITY_EMAIL=data.data.EMAIL
						  that.form3.INQUITY_USERNAME=data.data.USERNAME
						  that.form3.PN=that.$route.query.content;
					   });
				}
			});
			this.$parent.$parent.$parent.searchIndex=2;
			this.PN=this.$route.query.content;
			if(this.PN!=''&&this.PN!=undefined){
				this.form.PN=this.PN
				this.search()
			}
		},
		methods: {
			// 重新计算购物车数量
			getCartList(){
				let that = this;
				let params = {};
				params.BUYER_USERID = that.USERID
				getCartList(params).then(data => {
					that.$parent.$parent.$parent.$parent.$parent.$parent.SHOP_NUM=data.DataSumCount
				});
			},
			// 打开公司信息窗口
			company_msg(e){
				let params={
					COMPANYID:e+'',
				}
				let that=this
				// 获取卖家信息
				getSellerInfo(params).then(data => {
					 if(data.Result=='Success'){
					 	that.companyMsg=data.data
						console.log(that.companyMsg)
						that.conpany_dialog=true
					 }else{
						that.$message.error(data.Message)
					 }
				   });
			},
			// 向我们询价检测是否登录
			ask_yan(){
				if(this.Login){
					this.dialogFormVisible=true
				}else{
					this.login_win()
				}
			},
			// 向我们询价
			ask_us(formName){
				let that=this
				that.disabled=true
				that.$refs[formName].validate((valid) => {
					if (valid) {
						const params=this.form3;
						specialInquity(params).then(data => {
							that.disabled=false
							that.dialogFormVisible=false
							if (data.Result == 'Success'){
								that.$message({
									message:data.Message,
									type: 'success'
								});
							} else {
								that.$message.error(data.Message);
							}
						});
					} else {
						return false;
					}
				});
			},
			// 打开登陆窗口
			login_win(){
				this.$parent.$parent.$parent.$parent.$parent.$parent.login_win=true
			},
			// 重置分页
			search_new(){
				this.COUNT=30,
				this.PAGENUM=1,
				this.TOTAL=0,
				this.tableData=[],
				this.search()
			},
			// 搜索
			search(){
				if(this.activeName=='first'){
					const params=this.form;
					params.COUNT=this.COUNT;
					params.PAGENUM=this.PAGENUM;
					getChemicalsList(params).then(data => {
						if (data.Result == 'Success'&&data.data!=null) {
							for(let i=0;i<data.data.length;i++){
								data.data[i].NUM=1
							}
							this.tableData=data.data;
							this.TOTAL=data.pageSum;
							this.$parent.$parent.$parent.Chemicals_Count=data.dataSum;
						} else {
							// this.$message.error(data.Message);
							this.tableData=[];
							this.TOTAL=0;
							this.PAGENUM=1;
							this.$parent.$parent.$parent.Chemicals_Count=0
						}
						
					});
				}else{
					const params=this.form2;
					params.COUNT=this.COUNT;
					params.PAGENUM=this.PAGENUM;
					getChemicalsList(params).then(data => {
						if (data.Result == 'Success'&&data.data!=null) {
							this.tableData=data.data;
							this.TOTAL=data.pageSum;
							this.$parent.$parent.$parent.Chemicals_Count=data.dataSum;
						} else {
							// this.$message.error(data.Message);
							this.tableData=[];
							this.TOTAL=0;
							this.PAGENUM=1;
							this.$parent.$parent.$parent.Chemicals_Count=0
						}
					});
				}
			},
			// 选中列表中的项
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleSizeChange(e){
				this.PAGENUM=e
				this.search()
			},
			// handleEdit(index, row) {
			// 	console.log(index, row);
			// },
			// handleDelete(index, row) {
			// 	console.log(index, row);
			// },
			handleClick(tab, event) {
				this.PAGENUM=1;
			},
			// 加入购物车
			add_shopcar(row){
				let that=this
				if(!that.Login){
					that.$parent.$parent.$parent.$parent.$parent.$parent.login_win=true
					return
				}
				if(that.BUYER!=1){
					that.$alert('请先进行买家资质审核！', '提示', {
					          confirmButtonText: '确定',
					          type: 'warning'
					}).then(() => {
						that.$parent.$parent.$parent.$parent.$parent.$parent.$data.searchIndex=7
						that.$router.push('/person/Buyer')
					})
				}else{
					console.log(row)
					let params=[];
					let params_list={};
					params_list.BUYER_USERID=that.USERID;
					params_list.INVENTORYID=row.ID;
					params_list.COUNTNUM=row.NUM;
					params.push(params_list)
					intoCart(params).then(data => {
						if(data.Result=='Success'){
							this.$message({
								message:data.Message,
								type: 'success'
							});
							that.getCartList()
						}else{
							this.$message.error(data.Message);
							}
					});
				}
			},
			// 批量加入购物车
			allAdd_shopcar(){
				let that=this
				if(that.BUYER!=1){
					that.$alert('请先进行买家资质审核！', '提示', {
					          confirmButtonText: '确定',
					          type: 'warning'
					}).then(() => {
						that.$parent.$parent.$parent.$parent.$parent.$parent.$data.searchIndex=7
						that.$router.push('/person/Buyer')
					})
				}else{
					if(that.multipleSelection.length>0){
						let params=[];
						for(let i=0;i<that.multipleSelection.length;i++){
							let params_list={};
							params_list.BUYER_USERID=that.USERID;
							params_list.INVENTORYID=that.multipleSelection[i].ID;
							params_list.COUNTNUM=that.multipleSelection[i].NUM;
							params.push(params_list)
						}
						intoCart(params).then(data => {
							if(data.Result=='Success'){
								this.$message({
									message:data.Message,
									type: 'success'
								});
								that.getCartList()
							}else{
								this.$message.error(data.Message);
								}
						});
					}
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	/deep/.el-textarea__inner{
		min-height:70px!important;
	}
	.xiang {
		float: left
	}
	.search_win {
		width: 90%;
		height: auto;
		margin: 0 auto;
		padding: 20px;
		background-color: #FFFFFF;
		border-radius: 10px;
		margin-top:25px;
		box-shadow: 5px 5px 5px #c5c6c6;
	}
	.el-form-item {
		margin-bottom:20px
	}
	.el-input-number--mini{
		width:95px
	}
	.company_msg{
		margin-bottom:15px;
	}
	.company_msg div{
		display:inline-block;
		font-weight:bold;
		width:100px;
		text-align:right;
	}
	.avatar{
		width:80px;height:80px
	}
</style>
